

















import { VueConstructor } from 'vue';
import { defineComponent, PropType } from '@vue/composition-api';
import { GroupWithCommunity } from '@front-app/services/GroupsApi/GroupModel';
import SlidingPanel from '@front-app/components/modals/SlidingPanel.vue';
import { OpenSecurityMode, SecuritySettingsPanelMode } from './SecuritySettingsPanelData';
import AccessControl from './AccessControl.vue';
import CsrSettings from './CsrSettings.vue';
import JoinRequirements from './JoinRequirements.vue';
import PreviewSettings from './PreviewSettings.vue';

const CHILD_COMPONENTS_BY_MODE: Record<OpenSecurityMode, VueConstructor> = {
	[SecuritySettingsPanelMode.ACCESS_CONTROL]: AccessControl,
	[SecuritySettingsPanelMode.JOIN_REQUIREMENTS]: JoinRequirements,
	[SecuritySettingsPanelMode.PREVIEW]: PreviewSettings,
	[SecuritySettingsPanelMode.CSR]: CsrSettings,
};

export default defineComponent({
	components: { SlidingPanel },
	props: {
		mode: {
			type: String as PropType<SecuritySettingsPanelMode>,
			required: true,
		},
		group: {
			type: Object as PropType<GroupWithCommunity>,
			required: true,
		},
	},
	setup() {
		return {
			SecuritySettingsPanelMode,
			CHILD_COMPONENTS_BY_MODE,
		};
	},
});
